import { BrowserAuthOptions, BrowserSystemOptions, CacheOptions, Configuration, ILoggerCallback, PopupRequest } from '@azure/msal-browser';

export type BaseAuthConfig = Pick<
  BrowserAuthOptions,
  'clientId' | 'authority' | 'knownAuthorities' | 'redirectUri' | 'postLogoutRedirectUri'
>;

export type BaseCacheOptions = Pick<CacheOptions, 'cacheLocation' | 'storeAuthStateInCookie'>;

export type BaseCacheConfig = {
  cache: BaseCacheOptions;
};

export const createAuthConfig = ({
  clientId,
  authority,
  knownAuthorities,
  redirectUri,
  postLogoutRedirectUri,
}: BaseAuthConfig): Pick<Configuration, 'auth'> => {
  return {
    auth: {
      clientId,
      authority,
      knownAuthorities,
      redirectUri,
      postLogoutRedirectUri,
    },
  };
};

export const createCacheConfig = (cache: BaseCacheOptions): BaseCacheConfig => {
  return {
    cache: {
      cacheLocation: cache.cacheLocation || 'sessionStorage',
      storeAuthStateInCookie: cache.storeAuthStateInCookie || true,
    },
  };
};

export const createLoggerConfig = ({
  loggerCallback,
}: {
  loggerCallback: ILoggerCallback;
}): { system: Pick<BrowserSystemOptions, 'loggerOptions'> } => {
  return {
    system: {
      loggerOptions: {
        loggerCallback,
        piiLoggingEnabled: false,
      },
    },
  };
};

export const createBaseConfig = (
  authConfig: BaseAuthConfig,
  cacheConfig: BaseCacheOptions,
  loggerConfig: {
    loggerCallback: ILoggerCallback;
  },
): Configuration => {
  return {
    ...createAuthConfig(authConfig),
    ...createCacheConfig(cacheConfig),
    ...createLoggerConfig(loggerConfig),
  };
};

export const createLoginRequest = (scopes: string[]): PopupRequest => {
  return {
    scopes: [...scopes],
  };
};
